import React from "react";

import { SubscriptionForm } from "../components/SubscriptionForm";

export function HomePage() {
  return (
    <>
      <section className="hero">
        <div className="container hero-grid">
          <div>
            <p className="kicker">Voting position development</p>
            <h1>Build a clear position. Publish a credible guide.</h1>
            <p className="hero-copy">
              Review every item, align your organization, and publish one
              authoritative guide.
            </p>
            <SubscriptionForm idPrefix="home-updates" />
          </div>
          <div
            className="hero-panel"
            aria-label="Example published position guide"
          >
            <div className="hero-panel-top">
              <span>Position guide</span>
              <span>November 2026</span>
            </div>
            <h2>2027 Model Policy Proposals</h2>
            <p className="report-subtitle">Adopted positions at a glance</p>
            <div
              className="report-preview"
              role="table"
              aria-label="Example recommendations"
            >
              <div className="report-row report-heading" role="row">
                <span role="columnheader">Item</span>
                <span role="columnheader">Action</span>
                <span role="columnheader">Position</span>
              </div>
              <div className="report-row" role="row">
                <strong role="cell">A28-99</strong>
                <span role="cell">Insert rules of construction.</span>
                <span
                  className="report-position report-position-support"
                  role="cell"
                >
                  Support
                </span>
              </div>
              <div className="report-row" role="row">
                <strong role="cell">E70-99</strong>
                <span role="cell">Require exit signs to be blue.</span>
                <span
                  className="report-position report-position-oppose"
                  role="cell"
                >
                  Oppose
                </span>
              </div>
              <div className="report-row" role="row">
                <strong role="cell">G2-99</strong>
                <span role="cell">Switch sections 310 and 311.</span>
                <span
                  className="report-position report-position-none"
                  role="cell"
                >
                  No Position
                </span>
              </div>
            </div>
            <div className="report-analysis">
              <strong>Source record</strong>
              <span>Attached sources and adopted rationale.</span>
            </div>
          </div>
        </div>
      </section>

      <section className="home-workflow" aria-labelledby="workflow-heading">
        <div className="container">
          <div className="home-section-heading">
            <p className="kicker">One working record</p>
            <h2 id="workflow-heading">From agenda packet to public guide.</h2>
            <p>
              Bring in the source, make the decisions, and publish the result.
            </p>
          </div>
          <ol className="home-workflow-grid">
            <li>
              <span className="home-step-number" aria-hidden="true">
                01
              </span>
              <h3>Import the agenda</h3>
              <p>Paste rows or upload a CSV or PDF.</p>
            </li>
            <li>
              <span className="home-step-number" aria-hidden="true">
                02
              </span>
              <h3>Review in place</h3>
              <p>Work through every item without changing screens.</p>
            </li>
            <li>
              <span className="home-step-number" aria-hidden="true">
                03
              </span>
              <h3>Adopt a stance</h3>
              <p>
                Keep personal input separate from the organization position.
              </p>
            </li>
            <li>
              <span className="home-step-number" aria-hidden="true">
                04
              </span>
              <h3>Publish the guide</h3>
              <p>Release a clear web, print, and PDF record.</p>
            </li>
          </ol>
        </div>
      </section>

      <section className="home-scale" aria-labelledby="scale-heading">
        <div className="container home-scale-grid">
          <div className="home-scale-copy">
            <p className="kicker">Built for the long agenda</p>
            <h2 id="scale-heading">Thousands of items. One clear view.</h2>
            <p>
              Search, compare, and update positions without leaving the agenda.
            </p>
          </div>
          <div
            className="home-stance-preview"
            aria-label="Example position workspace"
          >
            <div className="home-stance-heading" aria-hidden="true">
              <span>Agenda item</span>
              <span>Personal</span>
              <span>Organization</span>
              <span>Other organizations</span>
            </div>
            <div className="home-stance-row">
              <span>
                <strong>ADM1-24</strong>
                <small>Source attached</small>
              </span>
              <span className="home-stance home-stance-gray">No position</span>
              <span className="home-stance home-stance-green">Support</span>
              <span>Compare stances</span>
            </div>
            <div className="home-stance-row">
              <span>
                <strong>E70-99</strong>
                <small>Source attached</small>
              </span>
              <span className="home-stance home-stance-red">Oppose</span>
              <span className="home-stance home-stance-red">Oppose</span>
              <span>Compare stances</span>
            </div>
          </div>
        </div>
      </section>

      <section className="home-assurance" aria-labelledby="assurance-heading">
        <div className="container">
          <div className="home-section-heading">
            <p className="kicker">A durable public record</p>
            <h2 id="assurance-heading">A guide readers can trust.</h2>
          </div>
          <div className="home-assurance-grid">
            <article>
              <h3>Traceable</h3>
              <p>Keep each item connected to its source material.</p>
            </article>
            <article>
              <h3>Comparable</h3>
              <p>Line up public and permitted organization stances.</p>
            </article>
            <article>
              <h3>Publication-ready</h3>
              <p>
                Share one versioned guide on the web, in print, or as a PDF.
              </p>
            </article>
          </div>
        </div>
      </section>

      <section className="home-final-cta" aria-labelledby="home-cta-heading">
        <div className="container home-final-cta-inner">
          <div>
            <p className="kicker">Start with the agenda</p>
            <h2 id="home-cta-heading">
              Turn the next packet into a clear position guide.
            </h2>
          </div>
          <div className="home-final-actions">
            <a className="button button-light" href="/guides/new">
              Create a guide
            </a>
            <a className="button home-outline-light" href="/library">
              View published agenda
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
